// @material-ui/core components
import { makeStyles } from "tss-react/mui";

// core components
import Button from "../CustomButtons/Button";
import styles from "../../styles/jss/nextjs-material-kit/pages/forumsStyle.js";
import Link from "next/link";
import {updateQueryString} from "../../util/url";
import React from "react";
import {useRouter} from "next/router";

const useStyles = makeStyles()(styles);

export default function ArticleLoginBarrier(props) {
    const { classes, cx } = useStyles();
    const router = useRouter();

    return (
        <div className={classes.loginBarrier}>
            <div className={classes.modalContent}>
                <p className={classes.modalTitle}>Log in</p>
                <p className={classes.modalText}>You need to log in to view more of this article.</p>
                <Link
                  href={updateQueryString(updateQueryString(router.asPath, "login", null), "redirectUrl", router.asPath)}
                  shallow={true}
                >
                    <Button className={cx(classes.darkButton + " " + classes.mediumButton)}>Log in</Button>
                </Link>
            </div>
        </div>
    )
}

